module.exports = __webpack_public_path__ + "static/media/earth.6388a1c2.svg";